import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { switchToOldInterface as switchToOldInterfaceAction } from '../../actions/grid-screen';
import {
    SwitchToOldInterfaceLink,
    SwitchToOldInterfaceLinkProps
} from '../../components/SwitchToOldInterfaceLink/SwitchToOldInterfaceLink';

export interface OwnProps {}

export type StateProps = {};

export type DispatchProps = SwitchToOldInterfaceLinkProps;

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        switchToOldInterface: () => {
            dispatch(switchToOldInterfaceAction());
        }
    };
};

export const SwitchToOldInterfaceLinkContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps
>(
    null,
    mapDispatchToProps
)(SwitchToOldInterfaceLink);
